(() => {
  // Desktop only: hover-capable pointers and >= 990px
  const mql = window.matchMedia('(hover: hover) and (min-width: 990px)');
  const enable = () => mql.matches;

  const closeAll = (except = null) => {
    document.querySelectorAll('details').forEach(d => {
      if (d !== except) d.removeAttribute('open');
    });
  };

  const bind = () => {
    if (!enable()) return;
    
    // DOM'un tamamen yüklenmesini bekle
    const headerRoot = document.querySelector('.section-header, header') || document.body;
    const detailsList = headerRoot.querySelectorAll('details');
    
    if (!detailsList.length) {
      // Eğer details bulunamazsa, biraz bekle ve tekrar dene
      setTimeout(() => {
        const retryDetails = headerRoot.querySelectorAll('details');
        if (retryDetails.length > 0) {
          bindToDetails(retryDetails, headerRoot);
        }
      }, 100);
      return;
    }
    
    bindToDetails(detailsList, headerRoot);
  };

  const bindToDetails = (detailsList, headerRoot) => {
    let closeTimer;

    detailsList.forEach(d => {
      const summary = d.querySelector(':scope > summary');
      const panel = d.querySelector('.manual-image-mega-menu, .header__submenu');
      
      // Search modal'ı hariç tut
      if (d.closest('.header__search') || d.closest('details-modal')) {
        return;
      }

      // Open on hovering the parent (summary)
      if (summary) {
        summary.addEventListener('mouseenter', () => {
          clearTimeout(closeTimer);
          closeAll(d);
          d.setAttribute('open', '');
        });
        // Also open when entering the details wrapper itself (gap-safe)
        d.addEventListener('mouseenter', () => {
          clearTimeout(closeTimer);
          closeAll(d);
          d.setAttribute('open', '');
        });

        summary.addEventListener('click', (e) => {
          if (enable() && summary.dataset.url) {
            e.preventDefault();
            window.location.href = summary.dataset.url;
          }
        });
      }

      // Keep open while hovering the panel; close shortly after leaving
      const armClose = () => {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => d.removeAttribute('open'), 120);
      };
      d.addEventListener('mouseleave', armClose);
      if (panel) {
        panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
        panel.addEventListener('mouseleave', armClose);
      }
    });

    // Leaving the whole header area closes everything
    headerRoot.addEventListener('mouseleave', () => closeAll(null));
  };

  // DOM hazır olduğunda çalıştır
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  // Viewport değişikliklerini dinle
  mql.addEventListener?.('change', () => {
    closeAll(null);
    bind();
  });
})();

// Mobile-specific functionality for split header navigation
(() => {
  // Only run on mobile devices
  const isMobile = () => window.innerWidth <= 749;
  
  const bindMobileNavigation = () => {
    if (!isMobile()) return;
    
    // Find all parent link buttons in mobile menu drawers
    const parentLinkButtons = document.querySelectorAll('.menu-drawer__parent-link-button');
    
    parentLinkButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const url = button.getAttribute('data-url');
        if (url && url !== '#') {
          window.location.href = url;
        }
      });
    });
    
    // Ensure back buttons work properly (they should already work with default behavior)
    const backButtons = document.querySelectorAll('.menu-drawer__back-button');
    backButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        // Let the default behavior handle the back navigation
        // This ensures the back button works as expected
      });
    });
  };
  
  // Bind on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindMobileNavigation);
  } else {
    bindMobileNavigation();
  }
  
  // Re-bind when viewport changes to mobile
  window.addEventListener('resize', () => {
    if (isMobile()) {
      bindMobileNavigation();
    }
  });
})();
